import React from "react";
import { RDV_BUTTONS } from "../../utils/whatsapp";

const OrientationSection: React.FC = () => {
  return (
    <section className="orientation-section">
      <div className="container">
        <div className="orientation-content text-center">
          <h2 className="orientation-title">
            Vous souhaitez être orienté avant de
            <br className="desktop-break" />
            prendre rendez-vous ?
          </h2>

          <p className="orientation-description">
            Expliquez-nous brièvement votre besoin. L’équipe Fouta Bio vous
            indiquera la prochaine étape
            <br className="desktop-break" />
            adaptée, sans établir de diagnostic à distance.
          </p>

          <div className="orientation-actions">
            {RDV_BUTTONS.map((rdv) => (
              <a
                key={rdv.country}
                href={rdv.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn orientation-btn ${
                  rdv.country === "SN" ? "whatsapp-btn" : "appointment-btn"
                }`}
              >
                {rdv.label}
              </a>
            ))}
          </div>

          <p className="orientation-note">
            Les échanges en ligne ne permettent pas d’établir un diagnostic.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OrientationSection;